module.exports = __webpack_public_path__ + "img/PCnew.0eac6b85.png";